import useModals from '@/composables/modals.js'
import { useUnlimitedTrialStore } from '@/stores/unlimitedTrial.js'
import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia'
import { watch } from 'vue'

export const useProactiveTriggersStore = defineStore('proactiveTriggers', () => {
  useUnlimitedTrialTrigger()

  return {}
})

function useUnlimitedTrialTrigger () {
  const { showUnlimitedTrialModal } = storeToRefs(useUnlimitedTrialStore())
  const { openUnlimitedTrialModal, closeUnlimitedTrialModal } = useModals()

  watch(showUnlimitedTrialModal, (show) => {
    if (show) {
      openUnlimitedTrialModal()
    } else {
      closeUnlimitedTrialModal()
    }
  })

  return {}
}

import.meta.hot?.accept(acceptHMRUpdate(useProactiveTriggersStore, import.meta.hot))
